import RibbonButton, { RibbonButtonState } from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';

const undo: RibbonButton = {
    key: 'undo',
    title: () => strings.undo,
    imageSrc: require('../svg/undo.svg'),
    shortcutWin: 'Ctrl+Z',
    shortcutMac: '⌘+Z',
    buttonState: formatState =>
        formatState.canUndo ? RibbonButtonState.Normal : RibbonButtonState.Disabled,
    onExecute: plugin => plugin.getEditor().undo(),
};

export default undo;
